
import { useEffect, useState } from 'react';

import useNavRoutes from '@usas/ui-web/state/security/UseNavRoutes';
import usePersonOrgRoleData from '@usas/ui-web/state/personOrgRole/UsePersonOrgRoleData';
import useEnvironmentVariableData from '@usas/ui-web/state/environmentVariable/UseEnvironmentVariableData';

const useTopTimesClubSelection = () => {
  const { navRoutes } = useNavRoutes();
  const { environmentVariableState, CLUB_TOP_TIMES_SEARCH_ROLE_GROUP_ID } = useEnvironmentVariableData();
  const { clearArrayData } = usePersonOrgRoleData();
  const [isReadyState, setIsReadyState] = useState(false);

  useEffect(() => {
    clearArrayData();
    setIsReadyState(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    isLoading: environmentVariableState.isLoading,
    CLUB_TOP_TIMES_SEARCH_ROLE_GROUP_ID,
    TOP_TIMES_CLUB_SEARCH_ROUTE: navRoutes?.TOP_TIMES_CLUB_SEARCH?.route,
    isReadyState
  };
};

export default useTopTimesClubSelection;